import { tierFor } from './tiers';

const CW = 1080;
const CH = 1350;
const FONT_D = '"Archivo Black", sans-serif';
const FONT_B = '"Bricolage Grotesque", sans-serif';

const loadImage = (src) => new Promise((resolve) => {
  const img = new Image();
  img.onload = () => resolve(img);
  img.onerror = () => resolve(null);
  img.src = src;
});

const fitText = (ctx, text, max, size, font) => {
  let s = size;
  ctx.font = `${s}px ${font}`;
  while (ctx.measureText(text).width > max && s > 40) { s -= 6; ctx.font = `${s}px ${font}`; }
};

const drawBackdrop = (ctx, color) => {
  ctx.fillStyle = '#0B1020';
  ctx.fillRect(0, 0, CW, CH);
  ctx.strokeStyle = 'rgba(148,163,184,0.08)';
  ctx.lineWidth = 2;
  for (let x = 0; x <= CW; x += 60) { ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, CH); ctx.stroke(); }
  for (let y = 0; y <= CH; y += 60) { ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(CW, y); ctx.stroke(); }
  const glow = ctx.createRadialGradient(CW / 2, 560, 40, CW / 2, 560, 620);
  glow.addColorStop(0, `${color}55`);
  glow.addColorStop(1, 'rgba(11,16,32,0)');
  ctx.fillStyle = glow;
  ctx.fillRect(0, 0, CW, CH);
  const dots = [[140, 220, '#38BDF8'], [930, 300, '#FACC15'], [180, 880, '#F43F5E'], [900, 820, '#38BDF8'], [520, 150, '#A3E635']];
  dots.forEach(([x, y, c]) => {
    ctx.shadowColor = c; ctx.shadowBlur = 40; ctx.fillStyle = c;
    ctx.beginPath(); ctx.arc(x, y, 18, 0, Math.PI * 2); ctx.fill();
  });
  ctx.shadowBlur = 0;
};

const drawScore = (ctx, { score, name, bestStreak }, tier) => {
  ctx.textAlign = 'center';
  ctx.fillStyle = '#A3E635';
  ctx.font = `700 34px ${FONT_B}`;
  ctx.fillText('SKY CATCH  ·  30 SECOND CHALLENGE', CW / 2, 120);
  ctx.fillStyle = '#CBD5E1';
  ctx.font = `600 44px ${FONT_B}`;
  ctx.fillText(name ? `${name} scored` : 'I scored', CW / 2, 380);
  ctx.shadowColor = tier.color; ctx.shadowBlur = 50;
  ctx.fillStyle = '#FFFFFF';
  ctx.font = `260px ${FONT_D}`;
  ctx.fillText(score.toLocaleString('en-IN'), CW / 2, 620);
  ctx.shadowBlur = 0;
  ctx.fillStyle = tier.color;
  ctx.beginPath(); ctx.roundRect(140, 700, CW - 280, 150, 75); ctx.fill();
  ctx.fillStyle = '#0B1020';
  fitText(ctx, tier.title.toUpperCase(), CW - 360, 92, FONT_D);
  ctx.fillText(tier.title.toUpperCase(), CW / 2, 808);
  ctx.fillStyle = '#94A3B8';
  ctx.font = `600 40px ${FONT_B}`;
  ctx.fillText(bestStreak ? `Best streak ${bestStreak}  ·  Can you beat me?` : 'Can you beat me?', CW / 2, 950);
};

const drawFooter = (ctx, logo) => {
  ctx.fillStyle = '#FFF4E6';
  ctx.beginPath(); ctx.roundRect(140, 1080, CW - 280, 170, 40); ctx.fill();
  if (logo) {
    const h = 120; const w = (logo.width / logo.height) * h;
    ctx.drawImage(logo, 190, 1105, w, h);
  }
  ctx.textAlign = 'right';
  ctx.fillStyle = '#1a1a1a';
  ctx.font = `44px ${FONT_D}`;
  ctx.fillText('trucrunch.in/play', CW - 190, 1180);
  ctx.fillStyle = '#E63946';
  ctx.font = `700 28px ${FONT_B}`;
  ctx.fillText('TOP 5 WIN A HAMPER', CW - 190, 1222);
};

export const renderShareCard = async (data) => {
  await document.fonts.ready;
  const logo = await loadImage('/trucrunch-logo.png');
  const c = document.createElement('canvas');
  c.width = CW; c.height = CH;
  const ctx = c.getContext('2d');
  const tier = tierFor(data.score);
  drawBackdrop(ctx, tier.color);
  drawScore(ctx, data, tier);
  drawFooter(ctx, logo);
  return new Promise((resolve) => c.toBlob(resolve, 'image/png'));
};
